var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 128,
    viewBox: "0 0 128 128",
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#3178c6",
    height: 128,
    rx: 64,
    width: 128
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m70.2317 80.356v12.5152c2.0081 1.0429 4.3831 1.8251 7.125 2.3466s5.6318.7822 8.6697.7822c2.9607 0 5.7734-.2868 8.438-.8604 2.6647-.5736 5.001-1.5188 7.0096-2.8355 2.008-1.3167 3.597-3.0375 4.769-5.1625 1.171-2.125 1.757-4.7518 1.757-7.8806 0-2.2684-.335-4.2565-1.004-5.9643s-1.635-3.2266-2.896-4.5563c-1.262-1.3298-2.774-2.5226-4.538-3.5786-1.7636-1.0559-3.7524-2.0532-5.9665-2.9919-1.6219-.6779-3.0765-1.3362-4.3638-1.975s-2.3814-1.2906-3.2825-1.9555-1.5962-1.3689-2.0854-2.112c-.4891-.743-.7337-1.5839-.7337-2.5225 0-.8605.2188-1.6361.6565-2.3271.4377-.6909 1.0555-1.2841 1.8536-1.7795s1.7765-.88 2.935-1.1537c1.1585-.2738 2.4458-.4107 3.8618-.4107 1.0298 0 2.1175.0782 3.2632.2347 1.1457.1564 2.2978.3976 3.4563.7235s2.2845.7366 3.3795 1.232c1.094.4954 2.104 1.069 3.031 1.7208v-11.6939c-1.879-.73-3.933-1.271-6.1595-1.623-2.227-.352-4.7821-.528-7.6656-.528-2.935 0-5.7155.3194-8.3415.9582s-4.9366 1.6361-6.9319 2.9919-3.5722 3.0832-4.7307 5.1821-1.7378 4.6084-1.7378 7.5286c0 3.7285 1.062 6.9094 3.186 9.5428 2.124 2.6335 5.3485 4.8627 9.6738 6.6878 1.6992.704 3.2825 1.395 4.75 2.0729 1.4674.6779 2.7354 1.3818 3.8038 2.1119s1.9116 1.5253 2.5295 2.3857.9268 1.8382.9268 2.9332c0 .8083-.1931 1.5579-.5793 2.2489-.3861.6909-.9718 1.2906-1.7571 1.799-.7852.5085-1.7635.9061-2.9349 1.1929s-2.5424.4302-4.1128.4302c-2.6775 0-5.3293-.4759-7.9553-1.4275-2.626-.9517-5.0589-2.3792-7.2988-4.2826zm-21.3764-31.0854h16.1447v-10.2706h-45v10.2706h16.0658v45.7294h12.7895z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/ts.b7a6fca99fe79a9de162ad97c13c8067.svg";
export { ForwardRef as ReactComponent };